import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import FormAddModules from './components/FormAddModules';

const ProfileAddModules = (props) => {
 
  return (<Container className="dashboard">
            <Row>
              <Col md={12}>
                <h3 style={{ marginBottom: 30,  color:"#024b82" }}>Agregar módulos</h3>
              </Col>
            </Row>
            <Row>
                <FormAddModules profile={props.location.state.profile}/>
            </Row>
          </Container>)
};

export default ProfileAddModules;